{
  "about.blocks": "Модерирани сервери",
  "about.contact": "Контакт:",
  "about.disclaimer": "Mastodon е бесплатен, open-source софтвер, и заштитен знак на Mastodon gGmbH.",
  "about.domain_blocks.preamble": "Mastodon вообичаено ви дозволува да прегледувате содржини и комуницирате со корисниците од било кој сервер во федиверзумот. На овој сервер има исклучоци.",
  "about.domain_blocks.silenced.explanation": "Вообичаено нема да гледате профили и содржина од овој сервер, освен ако не го пребарате намерно, или го заследите.",
  "about.domain_blocks.silenced.title": "Ограничено",
  "about.domain_blocks.suspended.explanation": "Податоците од овој сервер нема да бидат процесирани, зачувани или сменети и било која интеракција или комуникација со корисниците од овој сервер ќе биде невозможна.",
  "about.domain_blocks.suspended.title": "Суспендиран",
  "about.not_available": "Оваа информација не е достапна на овој сервер.",
  "about.powered_by": "Децентрализиран друштвен медиум овозможен од {mastodon}",
  "about.rules": "Правила на серверот",
  "account.add_or_remove_from_list": "Додади или одстрани од листа",
  "account.badges.bot": "Бот",
  "account.badges.group": "Група",
  "account.block": "Блокирај @{name}",
  "account.block_domain": "Сокријај се од {domain}",
  "account.blocked": "Блокиран",
  "account.cancel_follow_request": "Withdraw follow request",
  "account.edit_profile": "Измени профил",
  "account.endorse": "Карактеристики на профилот",
  "account.follow": "Следи",
  "account.followers": "Следбеници",
  "account.followers.empty": "Никој не го следи овој корисник сеуште.",
  "account.follows.empty": "Корисникот не следи никој сеуште.",
  "account.hide_reblogs": "Сокриј буст од @{name}",
  "account.link_verified_on": "Сопстевноста на овај линк беше проверен на {date}",
  "account.locked_info": "Статусот на приватност на овај корисник е сетиран како заклучен. Корисникот одлучува кој можи да го следи него.",
  "account.media": "Медија",
  "account.mention": "Спомни @{name}",
  "account.mute": "Зачути го @{name}",
  "account.muted": "Зачутено",
  "account.posts": "Тутови",
  "account.report": "Пријави @{name}",
  "account.share": "Сподели @{name} профил",
  "account.show_reblogs": "Прикажи бустови од @{name}",
  "account.unblock": "Одблокирај @{name}",
  "account.unblock_domain": "Прикажи {domain}",
  "account.unendorse": "Не прикажувај на профил",
  "account.unfollow": "Одследи",
  "account.unmute": "Зачути го @{name}",
  "account_note.placeholder": "Click to add a note",
  "alert.rate_limited.message": "Обидете се повторно после {retry_time, time, medium}.",
  "alert.unexpected.message": "Неочекувана грешка.",
  "alert.unexpected.title": "Упс!",
  "boost_modal.combo": "Кликни {combo} за да го прескокниш ова нареден пат",
  "bundle_column_error.retry": "Обидете се повторно",
  "bundle_modal_error.close": "Затвори",
  "bundle_modal_error.retry": "Обидете се повторно",
  "column.blocks": "Блокирани корисници",
  "column.community": "Локална временска зона",
  "column.directory": "Види профили",
  "column.domain_blocks": "Скриени домеини",
  "column.home": "Дома",
  "column.lists": "Листа",
  "column.mutes": "Заќутени корисници",
  "column.notifications": "Известувања",
  "column.pins": "Pinned toot",
  "column.public": "Федеративен времеплов",
  "column_back_button.label": "Назад",
  "column_header.hide_settings": "Скриј подесувања",
  "column_header.moveLeft_settings": "Премести колона влево",
  "column_header.moveRight_settings": "Премести колона вдесно",
  "column_header.show_settings": "Прикажи подесувања",
  "community.column_settings.media_only": "Само медиа",
  "compose_form.direct_message_warning_learn_more": "Научи повеќе",
  "compose_form.encryption_warning": "Posts on Mastodon are not end-to-end encrypted. Do not share any dangerous information over Mastodon.",
  "compose_form.hashtag_warning": "This post won't be listed under any hashtag as it is unlisted. Only public posts can be searched by hashtag.",
  "compose_form.lock_disclaimer.lock": "заклучен",
  "compose_form.placeholder": "Што имате на ум?",
  "compose_form.poll.duration": "Времетрање на анкета",
  "compose_form.spoiler.marked": "Текстот е сокриен зад предупредување",
  "compose_form.spoiler.unmarked": "Текстот не е сокриен",
  "confirmation_modal.cancel": "Откажи",
  "confirmations.block.confirm": "Блокирај",
  "confirmations.delete.confirm": "Избриши",
  "confirmations.delete.message": "Сигурни сте дека го бришите статусот?",
  "confirmations.delete_list.confirm": "Избриши",
  "confirmations.delete_list.message": "Дали сте сигурни дека сакате да го избришете списоков?",
  "confirmations.logout.confirm": "Одјави се",
  "confirmations.logout.message": "Дали сте сигурни дека сакате да се одјавите?",
  "confirmations.mute.confirm": "Заќути",
  "confirmations.unfollow.confirm": "Одследи",
  "conversation.delete": "Избриши разговор",
  "conversation.mark_as_read": "Означете како прочитано",
  "conversation.open": "Прегледај разговор",
  "conversation.with": "Со {names}",
  "directory.federated": "Од познати fediverse",
  "directory.local": "Само од {domain}",
  "embed.instructions": "Embed this status on your website by copying the code below.",
  "emoji_button.activity": "Активност",
  "emoji_button.food": "Храна &amp; Пијалаци",
  "emoji_button.nature": "Природа",
  "emoji_button.objects": "Објекти",
  "emoji_button.people": "Луѓе",
  "emoji_button.recent": "Најчесто користени",
  "emoji_button.search": "Барај...",
  "emoji_button.search_results": "Резултати од барање",
  "emoji_button.symbols": "Симболи",
  "emoji_button.travel": "Патувања и Места",
  "empty_column.account_timeline": "No toots here!",
  "empty_column.account_unavailable": "Недостапен профил",
  "empty_column.blocks": "Немате сеуште блокирано корисници.",
  "empty_column.bookmarked_statuses": "You don't have any bookmarked toots yet. When you bookmark one, it will show up here.",
  "empty_column.community": "Локалниот времеплов е празен. Објавете нешто јавно за да може да почне шоуто!",
  "empty_column.domain_blocks": "Немате сокриени домеини уште.",
  "empty_column.home": "Your home timeline is empty! Follow more people to fill it up. {suggestions}",
  "empty_column.list": "There is nothing in this list yet. When members of this list post new statuses, they will appear here.",
  "errors.unexpected_crash.report_issue": "Пријавете проблем",
  "follow_request.authorize": "Одобри",
  "follow_request.reject": "Одбиј",
  "getting_started.heading": "Започни",
  "hashtag.column_header.tag_mode.all": "и {additional}",
  "hashtag.column_header.tag_mode.any": "или {additional}",
  "hashtag.column_header.tag_mode.none": "без {additional}",
  "hashtag.column_settings.select.no_options_message": "Нема предлози",
  "hashtag.column_settings.select.placeholder": "Внеси хаштагови…",
  "hashtag.column_settings.tag_mode.all": "Сите овие",
  "hashtag.column_settings.tag_mode.any": "Било кои",
  "hashtag.column_settings.tag_mode.none": "Никои",
  "hashtag.column_settings.tag_toggle": "Стави додатни тагови за оваа колона",
  "home.column_settings.show_reblogs": "Прикажи бустирања",
  "home.column_settings.show_replies": "Прикажи одговори",
  "intervals.full.days": "{number, plural, one {# ден} other {# дена}}",
  "intervals.full.hours": "{number, plural, one {# час} other {# часа}}",
  "intervals.full.minutes": "{number, plural, one {# минута} other {# минути}}",
  "keyboard_shortcuts.back": "за да одите назад",
  "keyboard_shortcuts.blocked": "to open blocked users list",
  "keyboard_shortcuts.boost": "to boost",
  "keyboard_shortcuts.column": "to focus a status in one of the columns",
  "keyboard_shortcuts.compose": "to focus the compose textarea",
  "keyboard_shortcuts.down": "to move down in the list",
  "keyboard_shortcuts.enter": "to open status",
  "keyboard_shortcuts.federated": "to open federated timeline",
  "keyboard_shortcuts.heading": "Keyboard Shortcuts",
  "keyboard_shortcuts.home": "to open home timeline",
  "keyboard_shortcuts.legend": "to display this legend",
  "keyboard_shortcuts.local": "to open local timeline",
  "keyboard_shortcuts.mention": "to mention author",
  "keyboard_shortcuts.muted": "to open muted users list",
  "keyboard_shortcuts.my_profile": "to open your profile",
  "keyboard_shortcuts.notifications": "to open notifications column",
  "keyboard_shortcuts.open_media": "to open media",
  "keyboard_shortcuts.pinned": "to open pinned toots list",
  "keyboard_shortcuts.profile": "to open author's profile",
  "keyboard_shortcuts.reply": "одговори",
  "keyboard_shortcuts.requests": "to open follow requests list",
  "keyboard_shortcuts.search": "to focus search",
  "keyboard_shortcuts.spoilers": "to show/hide CW field",
  "keyboard_shortcuts.start": "to open \"get started\" column",
  "keyboard_shortcuts.toggle_hidden": "to show/hide text behind CW",
  "keyboard_shortcuts.toggle_sensitivity": "to show/hide media",
  "keyboard_shortcuts.toot": "to start a brand new toot",
  "keyboard_shortcuts.unfocus": "to un-focus compose textarea/search",
  "keyboard_shortcuts.up": "to move up in the list",
  "navigation_bar.domain_blocks": "Hidden domains",
  "navigation_bar.filters": "Замолќени зборови",
  "navigation_bar.follow_requests": "Следи покани",
  "navigation_bar.follows_and_followers": "Следења и следбеници",
  "navigation_bar.lists": "Листи",
  "navigation_bar.logout": "Одјави се",
  "navigation_bar.mutes": "Заќутени корисници",
  "not_signed_in_indicator.not_signed_in": "You need to sign in to access this resource.",
  "notification.reblog": "{name} boosted your status",
  "notifications.column_settings.poll": "Резултати од анкета:",
  "notifications.column_settings.push": "Пуш нотификации",
  "notifications.column_settings.reblog": "Бустови:",
  "notifications.column_settings.show": "Прикажи во колона",
  "notifications.column_settings.sound": "Свири звуци",
  "notifications.column_settings.status": "New toots:",
  "notifications.filter.all": "Сите",
  "notifications.filter.boosts": "Бустови",
  "notifications.filter.follows": "Следења",
  "notifications.filter.mentions": "Спомнувања",
  "notifications.filter.polls": "Резултати од анкета",
  "notifications.group": "{count} нотификации",
  "poll.closed": "Затворени",
  "poll.refresh": "Освежи",
  "poll.total_people": "{count, plural, one {# човек} other {# луѓе}}",
  "poll.total_votes": "{count, plural, one {# глас} other {# гласа}}",
  "poll.vote": "Гласај",
  "poll.voted": "Вие гласавте за овој одговор",
  "poll_button.add_poll": "Додадете нова анкета",
  "poll_button.remove_poll": "Избришете анкета",
  "privacy.change": "Штеловај статус на приватност",
  "privacy.public.short": "Јавно",
  "refresh": "Освежи",
  "relative_time.days": "{number}д",
  "relative_time.hours": "{number}ч",
  "relative_time.just_now": "сега",
  "relative_time.minutes": "{number}м",
  "relative_time.seconds": "{number}с",
  "reply_indicator.cancel": "Откажи",
  "report.forward": "Проследи до {target}",
  "report.forward_hint": "Оваа сметка е од друг сервер. Испрати анонимна копија од пријавата и таму?",
  "report.placeholder": "Додатни коментари",
  "report.submit": "Испрати",
  "report.target": "Пријавување {target}",
  "report_notification.attached_statuses": "{count, plural, one {# post} other {# posts}} attached",
  "search.placeholder": "Барај",
  "search_results.statuses": "Toots",
  "sign_in_banner.sign_in": "Sign in",
  "status.admin_status": "Open this status in the moderation interface",
  "status.copy": "Copy link to status",
  "status.edited_x_times": "Edited {count, plural, one {# time} other {# times}}",
  "status.open": "Expand this status",
  "status.reblogs.empty": "No one has boosted this toot yet. When someone does, they will show up here.",
  "status.title.with_attachments": "{user} posted {attachmentCount, plural, one {an attachment} other {# attachments}}",
  "tabs_bar.home": "Дома",
  "tabs_bar.notifications": "Нотификации",
  "time_remaining.days": "{number, plural, one {# ден} other {# дена}} {number, plural, one {остана} other {останаа}}",
  "time_remaining.hours": "{number, plural, one {# час} other {# часа}} {number, plural, one {остана} other {останаа}}",
  "time_remaining.minutes": "{number, plural, one {# минута} other {# минути}} {number, plural, one {остана} other {останаа}}",
  "time_remaining.moments": "Уште некои мига",
  "time_remaining.seconds": "{number, plural, one {# секунда} other {# секунди}} {number, plural, one {остана} other {останаа}}",
  "trends.counter_by_accounts": "{count, plural, one {{counter} person} other {{counter} people}} in the past {days, plural, one {day} other {# days}}",
  "upload_progress.label": "Uploading…"
}
